import { Box } from '@styles/flexBox';
import styled, { css } from 'styled-components';

export const PageColorList = styled(Box)`
  // padding-bottom: 10px;
  display: flex;
  //justify-content: space-between;

  @media (max-width: 768px) {
    flex-wrap: wrap;
  }

  ${(props) =>
    props.borderColor &&
    css`
      flex-grow: 1;
      justify-content: flex-end;
      padding: 0;
    `}

  ${(props) =>
    props.column &&
    css`
      flex-direction: column;
    `}

  ${(props) =>
    props.margin &&
    css`
      margin: ${props.margin};
    `}

  ${(props) =>
    props.pb &&
    css`
      padding-bottom: ${props.pb}px;
    `}
`;

export const MediaHeaderList = styled(Box)`
  display: flex;
`;

export const MediaHeaderItem = styled(Box)`
  cursor: pointer;
  width: 90px;
  height: 90px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  margin-right: 10px;
  background: #f2f6fc;
  border-radius: 15px;

  &:last-child {
    margin-right: 0;
  }

  ${(props) =>
    props.active &&
    css`
      border: 3px #ffc561 solid;
    `}
`;

export const MediaHeaderIcon = styled.img`
  width: 30px;
  height: 30px;

  @media (max-width: 567px) {
    width: 25px;
    height: 25px;
  }
`;

export const MediaHeaderTitle = styled(Box)`
  font-size: 15px;
  margin-top: 10px;
  color: #b4becc;

  @media (max-width: 567px) {
    font-size: 14px;
  }

  ${(props) =>
    props.active &&
    css`
      font-weight: bold;
    `}
`;

export const UploadImage = styled(Box)`
  display: none;

  ${(props) =>
    props.isShowingUpload &&
    css`
      width: 100%;
    `}

  ${(props) =>
    props.backgroundTypeImage &&
    css`
      width: 100%;
      height: 100%;
      margin-left: -1px;
    `}

  ${(props) =>
    props.isShowingImage &&
    css`
      display: block;
    `}

  ${(props) =>
    props.uploadFile &&
    css`
      display: flex;
      justify-content: left;
      align-items: center;
      // width: 303px;
      width: 100%;
      height: 152px;
    `}

  ${(props) =>
    props.isCircle &&
    css`
      // width: 100px;
      // height: 100px;
    `}

  ${(props) =>
    props.seoImage &&
    css`
      width: 100%;
      height: 100%;
      align-items: start;
      justify-content: start;
    `}

  ${(props) =>
    props.ifFullWidth &&
    css`
      width: 100%;
    `}
`;

export const HeaderTypeYouTubeLink = styled(Box)`
  display: none;
`;

export const PreviewFileBox = styled(Box)`
  position: relative;
  width: 303px;
  height: 152px;
  overflow: hidden;

  &:hover {
    div {
      display: block;
    }
  }

  @media (max-width: 767px) {
    width: 100%;

    iframe {
      width: 100% !important;
    }
  }

  ${(props) =>
    props.isFullWidth &&
    css`
      width: 100%;
    `}

  ${(props) =>
    props.uploadButtonLink &&
    css`
      width: 82px;
      height: 82px;
      border-radius: 4px;
    `}

  ${(props) =>
    props.seoImage &&
    css`
      width: 400px;
      height: 210px;
      border-radius: 8px;
    `}

  ${(props) =>
    props.backgroundTypeImage &&
    css`
      border-right: 8px;
      width: 100%;
      height: 100%;
    `}

  ${(props) =>
    props.uploadVideoSubpage &&
    css`
      min-height: 155px;
      display: flex;
      width: auto;
      height: auto;
    `}

  ${(props) =>
    props.insideHeaderCover &&
    css`
      margin-top: -15px;
      height: 150px;
    `}

  ${(props) =>
    props.isBigOnMobile &&
    css`
      @media (max-width: 767px) {
        height: 150px;
        width: 300px;
      }
    `}

  ${(props) =>
    props.insideFaq &&
    css`
      @media (max-width: 767px) {
        width: 82px;
      }
    `}

  ${(props) =>
    props.isCircle &&
    css`
      width: 100px;
      height: 100px;
    `}

  ${(props) =>
    props.imageSize &&
    css`
      width: ${props.imageSize};
      height: ${props.imageSize};
    `}

  ${(props) =>
    props.isFavicon &&
    css`
      width: 100px;
      height: 100px;
      border-radius: 8px;
    `}
`;

export const PreviewImage = styled.img`
  transform: translate(0, -20%);
  width: 303px;

  @media (max-width: 767px) {
    width: 100%;
  }

  ${(props) =>
    props.uploadFile &&
    css`
      object-fit: cover;
      height: 100%;
      width: 100%;
      transform: none;
      border-radius: 3px;
    `}

  ${(props) =>
    props.tagImage &&
    css`
      width: 200px;
    `}

  ${(props) =>
    props.uploadButtonLink &&
    css`
      object-fit: cover;
      width: 82px;
      height: 82px;

      @media (max-width: 767px) {
        width: 82px;
      }
    `}

  ${(props) =>
    props.seoImage &&
    css`
      width: 400px;
      height: 210px;
      transform: none;
      object-fit: cover;
      border-radius: 8px;
    `}

  ${(props) =>
    props.backgroundTypeImage &&
    css`
      width: 100%;
      height: 100%;
      object-fit: cover;
      transform: none;
      border-radius: 6px;
    `}


  ${(props) =>
    props.insideHeader &&
    css`
      transform: none;
      width: 240px;
      height: 330px;
      object-fit: cover;
      border-radius: 16px;
    `}

  ${(props) =>
    props.darkness &&
    css`
      filter: brightness(${100 - props.darkness}%);
    `}

  ${(props) =>
    props.insideHeaderCover &&
    css`
      transform: none;
      height: 150px;
      object-fit: cover;
      border-radius: 16px;
    `}

  ${(props) =>
    props.isBigOnMobile &&
    css`
      @media (max-width: 767px) {
        width: 100%;
        height: 100%;
        transform: none;
      }
    `}

  ${(props) =>
    props.isCircle &&
    css`
      border-radius: 50%;
    `}

  ${(props) =>
    props.isFavicon &&
    css`
      width: 100px;
      height: 100px;
      border-radius: 8px;
    `}
`;

export const UploadImageLoading = styled(Box)`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 303px;
  height: 152px;

  ${(props) =>
    props.uploadButtonLink &&
    css`
      height: auto;
      width: auto;
    `}

  ${(props) =>
    props.custom &&
    css`
      position: absolute;
      top: 0;
    `}

  ${(props) =>
    props.fullSize &&
    css`
      width: 100%;
      height: 100%;
    `}
`;

export const UploadDeleteFile = styled(Box)`
  display: none;
  position: absolute;
  top: 5px;
  right: 5px;
  z-index: 10;

  ${(props) =>
    props.isImageSvg &&
    css`
      right: unset;
      top: 0;
      left: 60px;
    `}
`;

export const ContactBox = styled.img`
  margin-right: 13px;
  width: 40px;
  height: 40px;
  cursor: pointer;
  border-radius: 8px;

  &:last-child {
    margin-right: 0;
  }

  ${(props) =>
    props.social &&
    css`
      margin-right: 0;
    `}
  ${(props) =>
    props.isDropDownImage &&
    css`
      width: 26px;
      height: 26px;
      margin: 0;
    `}
`;

export const UploadBackgroundImageBox = styled(Box)`
  margin-top: 10px;

  ${(props) =>
    props.uploadButtonLink &&
    css`
      display: flex;
      align-items: center;
      margin: 0;
    `}

  ${(props) =>
    props.uploadPreloader &&
    css`
      @media (max-width: 768px) {
        width: 100%;
      }
    `}



  ${(props) =>
    props.isShowingUpload &&
    css`
      width: 100%;
    `}

  ${(props) =>
    props.backgroundTypeImage &&
    css`
      margin-top: 0;
      height: 100%;
      display: flex;
      justify-content: center;
      align-items: center;
    `}

  ${(props) =>
    props.backgorundTypeImageBottom &&
    css`
      margin: 20px 0;
      justify-content: flex-start;
    `}

  ${(props) =>
    props.margin &&
    css`
      margin: ${props.margin};
    `}
`;

export const PreviewUnilinkContainer = styled(Box)`
  display: none;
  height: 100%;
  margin-top: 32px;

  @media (max-width: 1200px) {
    margin-left: 50px;
  }

  ${(props) =>
    props.isShowing &&
    css`
      display: block;
    `}

  ${(props) =>
    props.isStiky &&
    css`
      position: sticky;
      top: 40px;
    `}

  ${(props) =>
    props.preview &&
    css`
      @media (max-width: 576px) {
        display: none;
      }
    `}

  ${(props) =>
    props.isMobile &&
    css`
      @media (max-width: 576px) {
        margin: 50px 0 20px;
        display: block;
      }
    `}
`;

export const PreviewUnilInk = styled(Box)`
  margin-left: auto;
  margin-top: -25px;
  position: sticky;
  top: 20px;
  width: 350px;

  @media (max-width: 576px) {
    width: 320px;
  }

  ${(props) =>
    props.insideMobile &&
    css`
      margin-top: 0;

      @media (max-width: 1200px) {
        display: block;
      }
    `}

  ${(props) =>
    props.isMenu &&
    css`
      margin: 0 0 0 auto;
    `}

  ${(props) =>
    props.isDetails &&
    css`
      margin: 0 0 0 65px;
    `}
`;

export const PreviewUnilinkBox = styled(Box)`
  margin-left: 1px;
  margin-top: 7px;
  position: relative;
  z-index: 100;
  border: none;
  border-radius: 20px;
  background: #ffffff;
  overflow: hidden;
`;

export const PreviewUnilInkImage = styled.img`
  position: absolute;
  top: -5px;
  left: -6.5px;
  width: 343px;
  height: 660px;
  z-index: 101;
  pointer-events: none;

  @media (min-height: 795px) {
    height: 660px;
  }
`;

export const MediaNetworksCaption = styled(Box)`
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  margin: 20px 0 20px 0;

  ${(props) =>
    props.insideLook &&
    css`
      margin: 10px 0 20px 0;
    `}
`;

export const MediaNetworksCaptionBox = styled(Box)`
  display: flex;

  @media (max-width: 992px) {
    flex-wrap: wrap;
    justify-content: space-between;
  }

  @media (max-width: 568px) {
    &:last-child {
      margin-top: 16px;
    }
  }

  ${(props) =>
    props.hide &&
    css`
      display: none;
    `}

  ${(props) =>
    props.editBox &&
    css`
      @media (max-width: 568px) {
        &:last-child {
          margin-top: 0;
        }
      }
    `}

  ${(props) =>
    props.shopMenu &&
    css`
      width: 100%;
      align-items: center;
    `}

  ${(props) =>
    props.margin &&
    css`
      margin: ${props.margin};
    `}

  ${(props) =>
    props.disabled &&
    css`
      opacity: 0.4;
      cursor: default;
      pointer-events: none;
    `}
`;

export const TikTokList = styled(Box)`
  display: flex;
  flex-wrap: wrap;

  //@media (min-width: 768px) {
  //  margin-left: 20px;
  //}
`;

export const TikTokBox = styled(Box)`
  position: relative;
  margin-right: 10px;
  width: 30.8%;
  height: 0;
  padding-bottom: 56%;
  cursor: pointer;

  @media (max-width: 768px) {
    width: 48%;
    margin-right: 3.5%;
    margin-bottom: 3.5%;
    //padding-top: 2.5%;
    padding-bottom: 85%;
    border-radius: 12px;

    &:nth-child(2n + 2) {
      margin-right: 0;
    }
  }

  ${(props) =>
    props.third &&
    css`
      margin-right: 0;
    `}

  ${(props) =>
    props.editBox &&
    css`
      @media (max-width: 768px) {
        width: 45%;
        padding-bottom: 77%;
        border-radius: 8px;

        img {
          border-radius: 8px !important;
        }
      }
    `}
`;

export const TikTokImg = styled.img`
  display: flex;
  align-self: end;
  max-width: 100%;
  min-height: 100%;
  object-fit: cover;
  -moz-appearance: none;
  -webkit-appearance: none;

  @media (max-width: 768px) {
    border-radius: 12px;
  }

  ${(props) =>
    props.checked &&
    css`
      border: 3px #17ce17 solid;
      border-radius: 5%;
      opacity: 1;
    `}

  ${(props) =>
    !props.isEdit &&
    css`
      opacity: 0.5;
      filter: grayscale(100%);
    `}

  ${(props) =>
    props.absolute &&
    css`
      position: absolute;
    `}


  }
`;

export const TikTokButtonBox = styled(Box)`
  margin: 50px;
  display: flex;
  justify-content: center;
  align-items: center;

  ${(props) =>
    props.hide &&
    css`
      display: none;
    `}
`;

export const TikTokModalImageBox = styled(Box)`
  position: relative;
  width: 345px;

  @media (max-width: 568px) {
    width: 100%;
  }
`;

export const TikTokModalTitle = styled(Box)`
  font-size: 18px;
  font-weight: bold;

  @media (max-width: 768px) {
    margin-top: 15px;
  }

  ${(props) =>
    props.margin &&
    css`
      margin: ${props.margin};
    `}
`;

export const DeleteTikTokBox = styled(Box)`
  margin-right: 24px;

  @media (max-width: 768px) {
    margin: 0;
    width: 48%;
  }
`;

export const MediaCategories = styled(Box)`
  position: relative;
  ${(props) =>
    props.property &&
    css`
      margin-top: -34px;
    `}
`;

export const MediaCategoriesList = styled(Box)`
  margin-top: 12px;
  display: flex;
  flex-wrap: wrap;

  ${(props) =>
    props.margin &&
    css`
      margin: ${props.margin};
    `}
`;

export const MediaCategoryItem = styled(Box)`
  display: flex;
  align-items: center;
  font-size: 14px;
  margin-right: 10px;
  margin-bottom: 10px;
  background: var(--main-gray);
  border-radius: 36px;
  padding: 5px 10px;
  cursor: pointer;
  max-width: 330px;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;

  ${(props) =>
    props.width &&
    css`
      width: ${props.width};
    `}
  ${(props) =>
    props.button &&
    css`
      background: var(--block-background);
      border: 1px solid var(--border-color);
    `}

  ${(props) => props.property && css``}
  ${(props) =>
    props.margin &&
    css`
      margin: ${props.margin};
    `}
`;

export const MediaCategoryIconClose = styled.img`
  margin-top: 1px;
  margin-left: 10px;
  width: 10px;
  height: 10px;

  [data-theme='dark'] & {
    filter: invert(1);
  }

  ${(props) =>
    props.poitner &&
    css`
      cursor: pointer;
    `}

  ${(props) =>
    props.isDigital &&
    css`
      margin-left: 21px;
      margin-top: 5px;
    `}
`;

export const MediaCategoriesHead = styled(Box)`
  display: flex;
  justify-content: space-between;

  ${(props) =>
    props.property &&
    css`
      justify-content: flex-end;
    `}

  ${(props) =>
    props.isSettings &&
    css`
      line-height: 27px;
    `}
`;

export const MediaCategoriesTitle = styled(Box)`
  cursor: pointer;
  color: #00bfff;
  font-size: 13px;
`;

export const MediaPropertiesList = styled(Box)``;

export const MediaPropertiesItem = styled(Box)`
  position: relative;

  ${(props) =>
    props.margin &&
    css`
      margin: ${props.margin};
    `}

  ${(props) =>
    props.$propertyCard &&
    css`
      background: transparent;
      border: 0;
      border-bottom: 1px solid #ececef;
      border-radius: 0;
      padding: 8px 0 14px;
      margin-bottom: 4px;

      &:first-of-type {
        padding-top: 4px;
      }

      &:last-of-type {
        border-bottom: 0;
        margin-bottom: 0;
      }
    `}
`;

export const ButtonShapeBox = styled(Box)`
  margin: 10px 0 16px;
  display: flex;
  justify-content: start;
  gap: 16px;
  width: 100%;

  ${(props) =>
    props.postShadow &&
    css`
      justify-content: flex-start;
    `}
  ${(props) =>
    props.margin &&
    css`
      margin: ${props.margin};
    `}
`;

export const ImageShapeList = styled(Box)`
  display: flex;
  justify-content: space-between;
  overflow: hidden;

  @media (max-width: 768px) {
    margin-bottom: 12px;
    flex-wrap: wrap;
    gap: 14px;
    justify-content: normal;
  }
`;

export const ImageShapeItem = styled(Box)`
  //margin-top: -45px;
  height: 100px;
  cursor: pointer;

  @media (max-width: 576px) {
    height: 65px;
  }
`;

export const BackgroundImageSearchBox = styled(Box)``;

export const BackgroundImageSearchInputBox = styled(Box)`
  position: relative;
`;

export const BackgroundImageSearchIcon = styled.img`
  width: 20px;
  height: 20px;
`;

export const BackgroundImageSearchIconBox = styled(Box)`
  padding: 6px 0;
  position: absolute;
  top: 0;
  right: 3px;
  width: 40px;
  cursor: pointer;
  margin-left: 10px;
  margin-top: 3px;
  //outline: 1px solid deeppink;
`;

export const BackgroundImageText = styled(Box)`
  margin: 8px 0;
  font-size: 12px;
`;

export const BackgroundImageList = styled(Box)`
  display: flex;
  flex-wrap: wrap;
  ${(props) =>
    props.isUserMediaLibrary &&
    css`
      display: flex;
      justify-content: center;
      align-items: center;
      height: 100%;
    `}
`;

export const BackgroundImageUnsplash = styled.img`
  margin-right: 5.8px;
  margin-bottom: 5.8px;

  width: 24%;
  cursor: pointer;
  border-radius: 8px;
  object-fit: cover;

  &:nth-child(4n + 4) {
    margin-right: 0;
  }

  @media (max-width: 568px) {
    height: 104px;
    width: 23.5%;
  }

  ${(props) =>
    props.active &&
    css`
      border: 2px solid #ffbc49;
    `}

  ${(props) =>
    props.isUserMediaLibrary &&
    css`
      width: 120px;
      height: 120px;
    `}
`;

export const BackgroundVideoCoverr = styled.video`
  margin-right: 5.8px;
  margin-bottom: 5.8px;

  width: 24%;
  cursor: pointer;
  border-radius: 8px;
  object-fit: cover;

  &:nth-child(4n + 4) {
    margin-right: 0;
  }

  @media (max-width: 568px) {
    height: 130px;
    width: 23.5%;
  }

  ${(props) =>
    props.active &&
    css`
      border: 2px solid #ffbc49;
    `}
`;

export const BackgroundImageButtonBox = styled(Box)`
  margin: 10px 0;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;

  ${({ margin }) =>
    margin &&
    css`
      margin: ${margin};
    `}
`;

export const BackgroundImageSpinner = styled(Box)`
  margin: 10px 0;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const BackgroundImageEmptyBox = styled(Box)`
  margin: 10px 0;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const HeaderAvatarImageBox = styled(Box)`
  display: flex;
  align-items: center;
`;

export const MediaGalleryList = styled(Box)`
  display: flex;

  ${(props) =>
    props.margin &&
    css`
      margin: ${props.margin};
    `}
  ${(props) =>
    props.width &&
    css`
      width: ${props.width}px;
      height: ${props.width}px;
    `}

  ${(props) =>
    props.isPreview &&
    css`
      margin-left: 8px;
    `}
`;

export const MediaGalleryItem = styled(Box)`
  position: relative;
  width: 60px;
  height: 60px;
  margin-right: 10px;
  cursor: pointer;

  ${(props) =>
    props.product &&
    css`
      margin-bottom: 10px;
    `}

  ${(props) =>
    props.isDigital &&
    css`
      margin-bottom: 10px;
      width: 150px;
      height: 150px;
      border-radius: 8px;
      overflow: hidden;
    `}

  ${(props) =>
    props.isShop &&
    css`
      overflow: hidden;
      border-radius: 8px;
    `}
`;

export const MediaGalleryImage = styled.img`
  width: 100%;
  height: 100%;
  border-radius: 3px;
  object-fit: cover;
`;

export const MediaGalleryClose = styled(Box)`
  position: absolute;
  right: 3px;
  top: 3px;
  width: 22px;
  height: 22px;
  background: var(--main-background);
  border-radius: 50%;

  &:before,
  &:after {
    position: absolute;
    left: 10px;
    top: 5px;
    content: ' ';
    height: 12px;
    width: 2px;
    background-color: var(--main-black);
  }
  &:before {
    transform: rotate(45deg);
  }
  &:after {
    transform: rotate(-45deg);
  }
`;

export const IconLogo = styled.img`
  margin-right: 10px;

  ${(props) =>
    props.margin &&
    css`
      margin: ${props.margin};
    `}

  ${(props) =>
    props.width &&
    css`
      width: ${props.width};
    `}

  ${(props) =>
    props.height &&
    css`
      height: ${props.height};
    `}

  ${(props) =>
    props.chooseImage &&
    css`
      width: 400px;

      @media (max-width: 568px) {
        width: 100%;
      }
    `}
`;

export const CropImageBox = styled(Box)`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: auto;

  img {
    max-height: 430px;
  }
`;
